'use client';

import { MessageCircle, ExternalLink, Loader2 } from 'lucide-react';
import { useTelegramLink } from '@/hooks/use-telegram-link';
import { ApiError } from '@/lib/api';

export function TelegramLinkButton() {
  const { mutate, data, isPending, isSuccess, isError, error, reset } =
    useTelegramLink();

  if (isSuccess && data) {
    return (
      <div className="space-y-1 px-3">
        <a
          href={data.deep_link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-sidebar-foreground transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
        >
          <ExternalLink className="h-4 w-4" />
          Открыть в Telegram
        </a>
        <p className="px-3 text-xs text-muted-foreground">
          Ссылка действительна 10 мин
        </p>
        <button
          onClick={() => reset()}
          className="px-3 text-xs text-muted-foreground underline hover:text-sidebar-foreground"
        >
          Сбросить
        </button>
      </div>
    );
  }

  if (isError) {
    const apiErr = error instanceof ApiError ? error : null;
    const message =
      apiErr && apiErr.status === 503
        ? 'Бот не настроен'
        : 'Ошибка получения ссылки';

    return (
      <div className="space-y-1 px-3">
        <p className="px-3 text-xs text-red-400">{message}</p>
        <button
          onClick={() => reset()}
          className="px-3 text-xs text-muted-foreground underline hover:text-sidebar-foreground"
        >
          Попробовать снова
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={() => mutate()}
      disabled={isPending}
      className="flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-sidebar-foreground transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
    >
      {isPending ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <MessageCircle className="h-4 w-4" />
      )}
      Telegram
    </button>
  );
}
